import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import InputWithLabel from "components/forms/InputWithLabel";
import InputText from "components/forms/InputText";
import ButtonPrimary from "components/buttons/ButtonPrimary";

const CreateAutoresponder = styled.div`
  display: flex;
  flex-direction: column;
`;

const CreateAutoresponderText = styled.div`
  margin-top: 50px;

  line-height: 130%;
`;

const ButtonWrap = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
`;

const Warning = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

export default ({
  name,
  handleInputChange,
  onCreateAutoresponder,
  loadingCreate,
  warnings,
  errorMessage,
}) => {
  return (
    <CreateAutoresponder>
      <CreateAutoresponderText>
        Create an autoresponder, connect it to a mailing list, and send
        automatic messages to your leads.
      </CreateAutoresponderText>
      <InputWithLabel
        label="Name"
        width="300px"
        marginTop={css.VERTICAL_BOX_MARGIN_MEDIUM}
        tip="The autoresponder name is for your reference only and will not be visible to anyone else."
        tipId="autoresponderName"
      >
        <InputText
          type="text"
          name="name"
          value={name}
          placeholder="Enter the autoresponder name"
          onChange={handleInputChange}
          maxLength={40}
          warning={warnings.includes("name")}
        />
      </InputWithLabel>
      <ButtonWrap>
        <ButtonPrimary onClick={onCreateAutoresponder} disabled={loadingCreate}>
          Create Autoresponder
        </ButtonPrimary>
      </ButtonWrap>
      {errorMessage && <Warning>{errorMessage}</Warning>}
    </CreateAutoresponder>
  );
};
